module.exports = __webpack_public_path__ + "static/media/close.ae0a29b3.svg";